import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../../../..";
import { API_GET_OPEN_TASKS } from "../../../../Apis/ApiEndPoints";
import { CustomAction } from "../../../../store/customAction";
import { ITaksParams } from "./BasicInfoCardQuickActions";

export const GetOpenTasks = createAsyncThunk(
  "agent/GetOpenTasks",
  async (requestParams: ITaksParams, { dispatch }) => {
    const { providerId, policyId } = requestParams;
    const response = await CustomAction(
      Api.get(`${API_GET_OPEN_TASKS}/${providerId}/${policyId}`),
      dispatch,
      "agent/GetOpenTasks"
    );
    return response;
  }
);
